<template>
  <div id="app" class="bg-gray-50 min-h-screen">
    <!-- TopBar sadece auth gerektiren sayfalarda göster -->
    <TopBar v-if="showTopBar" />
    <router-view />
    <!-- TabBar sadece auth gerektiren sayfalarda göster -->
    <TabBar v-if="showTabBar" />
  </div>
</template>

<script>
import TopBar from './components/TopBar.vue'
import TabBar from './components/TabBar.vue'

export default {
  name: 'App',
  components: {
    TopBar,
    TabBar
  },
  computed: {
    showTopBar() {
      return this.$route.path !== '/signin' && this.$route.path !== '/signup'
    },
    showTabBar() {
      return this.$route.path !== '/signin' && this.$route.path !== '/signup'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}
</style>